import React, { Suspense, lazy, useState, useEffect } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from './pages/Home';
import ScrollToTop from './components/ScrollToTop/';
import './App.css';

const AnimatedCategory = lazy(() => import('./components/AnimatedCategory'));

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      try {
        await window.ethereum.send('metamask_injectHomepageScripts');
      } catch (e) {
        /**
         * To render the app in the desktop browser we need to set loading to false
         * as it throws by not finding the metamask_injectHomepageScripts event which is only
         * available in MM webview.
         *  */        
        setIsLoading(false);
        console.error(e);
      }
    }

    window.addEventListener('metamask_onHomepageScriptsInjected', () => {
      setIsLoading(false)
    })

    run()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading) return null

  return (
      <Router basename={'/dapps'}>
        <Suspense fallback={null}>
          <ScrollToTop>
            <div className="App">
              <Route exact path="/" component={Home} />
              <div className={'animated-wrapper-rule'}>
                <Route path="/:category" component={AnimatedCategory} />
              </div>
            </div>
          </ScrollToTop>
        </Suspense>
      </Router>
  );
}

export default App;
